import 'css/page/account.scss';
import { useContext, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { useIntl } from 'react-intl';
import { Spinner } from 'components';
import { authContext } from 'helpers/services';


let ResetPassword = () => {
    let location = useLocation();
    let history = useHistory();

    let { formatMessage } = useIntl();

    let authService = useContext(authContext);

    let forgotSchema = yup.object({
        code: yup.string().required().default(''),
        email: yup.string().required().default((location.state as any).email),
        newPassword: yup.string().required().default(''),
        newPasswordConfirm: yup.string()
            .oneOf([yup.ref('newPassword'), ''], formatMessage({ id: "ERR_PASSWORD_MISMATCH" }))
            .required()
            .default('')
    });

    let [isLoading, setLoading] = useState(false);


    return (
        <div className="accountpanel">
            <div className="bg-white p-0">
                <div className="container py-4 px-5">
                <div className="row">
                        <div className="col-12">
                            <h4 className="pb-4">{formatMessage({ id: "RESET_PASSWORD" })}</h4>
                        <h6 className="text-muted">{formatMessage({ id: "RESET_PASSWORD_SUBTITLE" })}</h6>
                        <Formik
                            validationSchema={forgotSchema}
                            initialValues={forgotSchema.getDefault()}
                            onSubmit={async (values, action) => {
                                try {
                                    setLoading(true);
                                    await authService.forgotPasswordSubmit(values.email, values.code, values.newPassword);
                                    history.replace('/account/login');

                                } catch (err: any) {
                                    action.setSubmitting(false);
                                    setLoading(false);
                                    toast.error(err.message);
                                }
                            }}
                        >
                            <Form>
                                <div className="form-group">
                                    <label htmlFor="email">{formatMessage({ id: "EMAIL" })}</label>
                                    <Field
                                        id="email"
                                        className="form-control"
                                        disabled={isLoading}
                                        name="email"
                                        type="email"
                                    />
                                    <ErrorMessage name="email" component="span">
                                        {message => <span className="text-danger">{formatMessage({ id: 'FIELD_REQUIRED' }, { field: formatMessage({ id: 'EMAIL' }) })}</span>}
                                    </ErrorMessage>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="code">{formatMessage({ id: "CODE" })}</label>
                                    <Field
                                        id="code"
                                        className="form-control"
                                        disabled={isLoading}
                                        name="code"
                                    />
                                    <ErrorMessage name="code" component="span">
                                        {message => <span className="text-danger">{formatMessage({ id: 'FIELD_REQUIRED' }, { field: formatMessage({ id: 'CODE' }) })}</span>}
                                    </ErrorMessage>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="newpassword">{formatMessage({ id: "NEWPASSWORD" })}</label>
                                    <Field
                                        id="newpassword"
                                        className="form-control"
                                        disabled={isLoading}
                                        name="newPassword"
                                        type="password"
                                    />
                                    <ErrorMessage name="newPassword" component="span">
                                        {message => <span className="text-danger">{formatMessage({ id: 'FIELD_REQUIRED' }, { field: formatMessage({ id: 'NEWPASSWORD' }) })}</span>}
                                    </ErrorMessage>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="newPasswordConfirm">{formatMessage({ id: "PASSWORD_CONFIRMATION" })}</label>
                                    <Field
                                        id="newPasswordConfirm"
                                        className="form-control"
                                        disabled={isLoading}
                                        name="newPasswordConfirm"
                                        type="password"
                                    />
                                    <ErrorMessage name="newPasswordConfirm" component="span">
                                        {message => <span className="text-danger">{formatMessage({ id: 'FIELD_REQUIRED' }, { field: formatMessage({ id: 'PASSWORD_CONFIRMATION' }) })}</span>}
                                    </ErrorMessage>
                                </div>

                                {isLoading && <Spinner />}
                                {isLoading === false &&
                                    <button
                                        style={{ float: 'right' }}
                                        className="btn btn-success btn-block"
                                        type="submit"
                                    >
                                        {formatMessage({ id: "RESET_PASSWORD" })}
                                    </button>
                                }
                            </Form>
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
        </div>

    )
}

export default ResetPassword;